import { Backdrop, Modal } from "@mui/material";
import { FC } from "react";
import "./AnnouncementModal.scss";
import { useUserContext } from "../../../context/UserContext";
import { getImage } from "../../../api/ApiPath";
import { autoPlay } from "react-swipeable-views-utils";
import SwipeableViews from "react-swipeable-views";
const AutoPlaySwipeableViews = autoPlay(SwipeableViews);

type Props = {
  isOpen: boolean;
  onClose?: () => void;
};
const AnnouncementModal: FC<Props> = ({ isOpen, onClose }) => {
  const { currentCompanyInfo } = useUserContext();

  return (
    <Modal
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      open={isOpen}
      onClose={onClose}
      closeAfterTransition
      slots={{ backdrop: Backdrop }}
      slotProps={{
        backdrop: {
          timeout: 500,
        },
      }}
    >
      <div className={"img-roots"}>
        {currentCompanyInfo?.announcementObj && (
          <AutoPlaySwipeableViews className={"anno-img-root"}>
            {currentCompanyInfo.announcementObj
              ?.filter((value) => value.photoUrl !== null)
              .map((imageUrl, index) => (
                <div key={index}>
                  <div
                    onClick={() => {
                      onClose?.();
                    }}
                    className={"anno-img-main"}
                  >
                    <div className={"text"}>
                      <div className={"x"}>X</div>
                    </div>
                  </div>
                  {imageUrl && (
                    <img
                      className={"anno-img"}
                      src={getImage(imageUrl?.photoUrl ?? "")}
                      alt={`Image ${index}`}
                    />
                  )}
                </div>
              ))}
          </AutoPlaySwipeableViews>
        )}
      </div>
    </Modal>
  );
};
export default AnnouncementModal;
